'use client';

import { EmblaCarouselType } from 'embla-carousel';
import { ReactNode, RefObject, useCallback, useRef } from 'react';
import { useInView } from '@/shared/lib/hooks/useIsInView';
import { CategoriesScrollIndicator } from './categories-scroll-indicator';

type RenderProps = {
    firstRef: RefObject<null>;
    lastRef?: RefObject<null>;
};

type Props = {
    emblaApi?: EmblaCarouselType;
    disabled?: boolean;
    children: (props: RenderProps) => ReactNode;
};
export const CategoriesScrollIndicators = ({ children, emblaApi, disabled = false }: Props) => {
    const firstRef = useRef(null);
    const lastRef = useRef(null);
    const prevBtnDisabled = useInView(firstRef, {
        threshold: 0.5,
    });
    const nextBtnDisabled = useInView(lastRef, {
        threshold: 0.5,
    });

    const handleScroll = useCallback(
        (direction: 'left' | 'right') => {
            if (!emblaApi) return;
            const selectedIndex = emblaApi.selectedScrollSnap();
            const slidesInView = emblaApi.slidesInView();
            emblaApi.scrollTo(
                selectedIndex + (direction === 'left' ? -1 : 1) * Math.round(slidesInView.length / 2),
            );
        },
        [emblaApi],
    );

    if (disabled) {
        return children({ firstRef, lastRef });
    }

    return (
        <>
            {!prevBtnDisabled && (
                <CategoriesScrollIndicator side="left" onClick={() => handleScroll('left')} />
            )}
            {children({ firstRef, lastRef })}
            {!nextBtnDisabled && (
                <CategoriesScrollIndicator side="right" onClick={() => handleScroll('right')} />
            )}
        </>
    );
};
